import React, { useEffect, useRef, useState } from 'react';
import {
	Box,
	ClickAwayListener,
	FormLabel,
	Grow,
	MenuItem,
	MenuList,
	Paper,
	Popper,
	Tab,
	Tabs,
	TextField,
	Typography,
	FormControlLabel,
	Switch,
	InputAdornment,
	Avatar,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
	DollarIcon,
	EuroIcon,
	KeyResultIcon,
	NumbersIcon,
	PercentageIcon,
	PoundIcon,
	RupeeIcon,
	YenIcon,
} from '../../../../config/svg/MyGoalSvg';
import { CalendarIcon, KababIcon, MetricIcon, ReportsTooltipIcon } from '../../../../config/svg/CommonSvgIcon';
import ReactDateRangePicker from '../../../Common/ReactDateRangePicker';
import { Enums } from '../../../../config/enums';
import { useSelector } from 'react-redux';
import { OKRButton } from '../../../Common/OKRButton';
import { getLocalStorageItem } from '../../../../services/StorageService';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { ErrorIcon } from '../../../../config/svg/formElementIcons';
import { DialogComponent } from '../../../Admin/CommonComponent/DialogComponent';
import { NumberFormatComponent } from '../../../Common/NumberFormat';
import { getUserDetails, getUserName } from '../../../../config/utils';

export const DefaultKpiAttributesTabPanel: React.FC<any> = (props: any) => {
	const { children, value, index } = props;
	return (
		<Box
			role='tabpanel'
			hidden={value !== index}
			id={`default-kr-attributes-${index}`}
			aria-labelledby={`default-kr-attributes-${index}`}
			{...props}
		>
			{value === index && <Box>{children}</Box>}
		</Box>
	);
};
DefaultKpiAttributesTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index: number) {
	return {
		id: `default-kr-attributes-tabpanel-${index}`,
		'aria-controls': `default-kr-attributes-tabpanel-${index}`,
	};
}

export const DefaultKpiAttributes = (props: any) => {
	const {
		defaultOkrFormDetails,
		krDetails,
		krAttrDateError,
		keyData,
		setKeyData,
		// krAttributeEdited,
		setKrAttributeEdited,
		mode,
	} = props;
	const moment = extendMoment(Moment);
	const [selectedMetricDetail, setSelectedMetricDetail] = useState<any>({});
	useEffect(() => {
		setKeyData({ ...krDetails });
	}, []);
	useEffect(() => {
		const { metricId } = krDetails;
		const { metricMasters } = okrMasterData;
		const selectedMetricId = metricId ? metricId : keyData?.metricId === 0 ? 0 : keyData?.metricId;
		const selectedCurrencyId = krDetails?.currencyId ? krDetails.currencyId : keyData?.currencyId;
		let selectedCurrencyDetail: any = {};
		const selectedMetric =
			metricMasters && metricMasters.length
				? metricMasters.find((item: any) => item.metricId === selectedMetricId)
				: null;
		if (selectedMetric && selectedMetric?.name === 'Currency') {
			const { metricDataMaster } = selectedMetric;
			const selectedCurrency =
				metricDataMaster && metricDataMaster.length
					? metricDataMaster.find((item: any) => item.dataId === selectedCurrencyId)
					: null;
			selectedCurrencyDetail = selectedCurrency;
		}
		setSelectedMetricDetail({ selectedMetric, selectedCurrencyDetail });
	}, [krDetails, keyData]);
	const { t } = useTranslation();
	const prgressMeasureRef: any = useRef();
	const { okrMasterData } = useSelector((state: any) => state.okrReducer);
	const loggedInUserDetail = getUserDetails();
	const currentUser = getLocalStorageItem('currentUser')
		? JSON.parse(getLocalStorageItem('currentUser') || '{}')
		: null;
	const [selectedKrDateRange, setSelectedKrDateRange] = useState<any>(null);
	const [anchorElCallouts, setAnchorElCallouts] = useState(null);
	const [selectedCurrency, setSelectedCurrency] = useState<any>(null);
	const [isNoUnitOrBoolean, setIsNoUnitOrBoolean] = useState<any>(null);
	const [metricData, setMetricData] = useState<any>([]);
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [openMenu, setOpenMenu] = useState<boolean>(false);
	//const [anchorEl, setAnchorEl] = useState<any>(null);
	const [open, setOpen] = useState<boolean>(false);
	const [modalProps, setModalProps] = useState<any>({ open: false, message: '', details: '' });

	useEffect(() => {
		if (Boolean(okrMasterData)) {
			setMasterData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [okrMasterData]);
	useEffect(() => {
		if (krDetails?.krItem) {
			setKeyData(krDetails?.krItem);
			const { startDate, endDate } = krDetails?.krItem || {};
			if (startDate && endDate) {
				setSelectedKrDateRange(moment().range(new Date(startDate), new Date(endDate)));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [krDetails]);

	const setMasterData = async () => {
		try {
			const { metricMasters } = okrMasterData || {};
			const updatedData =
				Boolean(metricMasters) && metricMasters.length
					? metricMasters.map(async (item: any, index: number) => {
							let SvgIcon: any = `${item.name}Icon`;
							let Icon: any = await import(`../../../../config/svg/MyGoalSvg`);
							item.Component = Icon[SvgIcon];
							item.activeButton = '';
							return item;
					  })
					: [];
			setMetricData(await Promise.all(updatedData));
		} catch (e) {}
	};

	const getCurrencyIcon = (currencyName: String) => {
		switch (currencyName) {
			case 'Dollar':
				return <DollarIcon />;
			case 'Euro':
				return <EuroIcon />;
			case 'Rupee':
				return <RupeeIcon />;
			case 'Yen':
				return <YenIcon />;
			case 'Pound':
				return <PoundIcon />;
			default:
				break;
		}
	};

	const setActiveMetric = (item: any) => {
		let metricId = keyData?.metricId;
		if (metricId === item.metricId) {
			return 'active';
		} else if (metricId === Enums.ZERO && item.metricId === Enums.FIVE) {
			//return 'active';
		}

		return item.activeButton;
	};
	const CurrencyList: React.FC<any> = ({ open }) => {
		const { metricMasters } = okrMasterData;
		const currencyMetric =
			Boolean(metricMasters) && metricMasters.length && metricMasters.find((item: any) => item.metricId === 2);
		const currencyList = Boolean(currencyMetric) && currencyMetric.metricDataMaster;

		return (
			<MenuList autoFocusItem={open}>
				{Boolean(currencyList) && currencyList.length ? (
					currencyList.map((item: any) => (
						<MenuItem onClick={() => handleCurrencySelection(item)}>
							{getCurrencyIcon(item.name)}
							{item.name}
						</MenuItem>
					))
				) : (
					<></>
				)}
			</MenuList>
		);
	};
	const handleOpen = (event: any) => {
		setAnchorEl(event.currentTarget);
		setOpen(true);
	};
	const handleClose = () => {
		setAnchorEl(null);
		setOpenMenu(false);
		setOpen(false);
	};
	const handleMetric = (event: any, item: any) => {
		try {
			if (mode === 'Edit' && defaultOkrFormDetails?.status === Enums.TWO && keyData?.status === Enums.TWO) {
				setModalProps({
					open: true,
					message: '',
					details: {
						deleteType: 'KRMetricChange',
						headingText: t('changingMetricAlert'),
						subHeading: t('stillWantToChange'),
						confirmMsg: t('toConfirmEnterText'),
						matchString: Enums.METRIC_TEXT,
						item,
						event,
					},
				});
			} else {
				if (item?.metricId === Enums.TWO) {
					setAnchorEl(event.currentTarget);
					setOpenMenu(true);
				} else {
					setKeyData({ ...keyData, metricId: item.metricId || Enums.ZERO, currencyId: Enums.ZERO });
					setKrAttributeEdited(true);
				}
			}
		} catch (e) {
			console.error(e);
		}
	};
	const handleCurrencySelection = (selectedCurrency: any) => {
		try {
			if (selectedCurrency) {
				setSelectedCurrency(selectedCurrency);
				setIsNoUnitOrBoolean(selectedCurrency);
				setKeyData({ ...keyData, currencyId: selectedCurrency.dataId || Enums.ZERO, metricId: Enums.TWO });
				setKrAttributeEdited(true);
				setAnchorEl(null);
				setOpenMenu(false);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleIsAddContributorAllowClick = (event: any) => {
		try {
			const { checked } = event?.target || {};
			setKeyData({ ...keyData, isAddContributorAllow: Boolean(checked) });
			setKrAttributeEdited(true);
		} catch (error) {
			console.error(error);
		}
	};
	const handleKrNameChange = (event: any) => {
		try {
			const { value } = event?.target || {};
			setKeyData({ ...keyData, keyDescription: value });
			setKrAttributeEdited(true);
		} catch (error) {
			console.error(error);
		}
	};

	const handleConfirmationCloseModal = async (e: any, type: any) => {
		try {
			// e.preventDefault();
			if (type === 1) {
				const { details } = modalProps || {};
				if (details && details?.deleteType === 'KRMetricChange') {
					const { item, event } = details || {};
					if (item?.metricId === Enums.TWO) {
						setAnchorEl(event.currentTarget);
						setOpenMenu(true);
					} else {
						setKeyData({ ...keyData, metricId: item.metricId || Enums.ZERO, currencyId: Enums.ZERO });
						setKrAttributeEdited(true);
					}
				}
				setModalProps({ open: false, message: '', details: '' });
			} else {
				setModalProps({ open: false, message: '', details: '' });
			}
		} catch (error) {
			console.error(error);
		}
	};
	// console.log('DefaultKeyResultAttributes ===> ', defaultOkrFormDetails, krDetails);
	// console.log('DefaultKeyResultAttributes ===> ', keyData, selectedKrCycleDetails, selectedKrDateRange);

	return (
		<>
			<Box className='drawer-content-panel'>
				<form className='drawer-form-fields' noValidate autoComplete='off'>
					<Box className='drawer-input-field helperText-bottom' id='kpi-name'>
						<TextField
							fullWidth
							multiline
							minRows={2}
							maxRows={2}
							value={keyData?.keyDescription || ''}
							InputProps={{
								'aria-label': t('kpiLabel'),
								disableUnderline: true,
								disabled: keyData?.isTargetModificationAllowed === true,
							}}
							disabled={keyData?.isTargetModificationAllowed === true}
							id='inputKpiTitle'
							//label={t('kpiLabel')}
							onChange={handleKrNameChange}
							error={keyData?.isKrNameError}
							helperText={
								keyData?.isKrNameError && keyData?.krNameErrorMsg ? (
									<>
										<ErrorIcon />
										{keyData?.krNameErrorMsg}
									</>
								) : (
									''
								)
							}
						/>
					</Box>
					<Box className='drawer-input-field  kr-measure-unit choose-metric-field'>
						<FormLabel id='metric-label' className='label-des' component='legend' ref={prgressMeasureRef}>
							<MetricIcon />
							{t('progressMeasurement')}
						</FormLabel>
						<Box className='choose-metric-msg'>
							<Typography id='metric-helptext' className='short-des-text'>
								{t('chooseMetricTypeMessage')}
							</Typography>
						</Box>
						<Box className='display-flex'>
							{metricData.map((item: any, index: number) => {
								const { Component } = item;
								return (
									<OKRButton
										className={`measure-btn ${item.name?.toLowerCase()}-btn ${setActiveMetric(item)}`}
										handleClick={(event: any) => {
											//setCallOut && setCallOut(initialCallout);
											handleMetric(event, item);
											//callOutMetricsField(item);
										}}
										key={index}
										id={`measure-btn-${index}`}
										icon={<Component />}
										text={
											item.name === 'Currency' ? (
												<>
													{item.description}
													<KababIcon />
												</>
											) : (
												item.description
											)
										}
										disabled={keyData.isEditable === false}
										// title={
										// 	!getLocalStorageItem('showCallouts') || anchorElCallouts === null ? (
										// 		item.name === 'Percentage' ? (
										// 			t('percentageMetricText')
										// 		) : item.name === 'Numbers' ? (
										// 			t('numberMetricText')
										// 		) : item.name === 'Currency' ? (
										// 			t('currencyMetricText')
										// 		) : item.name === 'Boolean' ? (
										// 			t('booleanMetricText')
										// 		) : item.name === 'NoUnits' ? (
										// 			t('noUnitsMetricText')
										// 		) : (
										// 			<></>
										// 		)
										// 	) : (
										// 		''
										// 	)
										// }
										tooltipClassName='tooltip-layout4'
									/>
								);
							})}
							<Popper className='popper-menu-list' open={openMenu} anchorEl={anchorEl} transition placement='right'>
								{({ TransitionProps }) => (
									<Grow {...TransitionProps}>
										<Paper>
											<ClickAwayListener onClickAway={handleClose}>
												<CurrencyList open={openMenu} />
											</ClickAwayListener>
										</Paper>
									</Grow>
								)}
							</Popper>
						</Box>
						<Box className='helperText-bottom'>
							{keyData?.isMetricTypeError || keyData?.isMetricCurrencyError ? (
								<span className='error-field'>
									<ErrorIcon />
									{keyData?.krMetricTypeErrorMsg || keyData?.krMetricCurrencyErrorMsg || t('metricTypeRequired')}
								</span>
							) : (
								<></>
							)}
						</Box>
					</Box>
					{keyData?.metricId ? (
						<Box className='drawer-input-field'>
							<Box className='kr-metrics-fileds' /* {...({ ref: metricsFieldRef } as any)} */>
								<Box className='kr-metrics-fileds-inner'>
									<TextField
										value={keyData?.startValue || ''}
										disabled={keyData.isEditable === false}
										className='current-value helperText-bottom'
										id={'kr-start-date'}
										label={t('start')}
										placeholder={selectedCurrency ? '0' : '0'}
										fullWidth
										error={(krAttrDateError?.type === 'startValue' && krAttrDateError?.error) || ''}
										helperText={
											(krAttrDateError?.type === 'startValue' && krAttrDateError?.helperText && (
												<>
													<ErrorIcon />
													{krAttrDateError?.helperText}
												</>
											)) ||
											''
										}
										onChange={(event: any) => {
											setKeyData({ ...keyData, startValue: event.target.value });
										}}
										InputLabelProps={{
											shrink: true,
										}}
										inputProps={{ maxLength: Enums.MAX_LENGTH_CURRENT_TARGET }}
										InputProps={{
											...(selectedMetricDetail &&
												selectedMetricDetail?.selectedMetric?.name !== 'Percentage' && {
													inputComponent: NumberFormatComponent,
												}),
											startAdornment: (
												<InputAdornment position='start'>
													{selectedMetricDetail && selectedMetricDetail?.selectedMetric?.name === 'Percentage' ? (
														<PercentageIcon />
													) : selectedMetricDetail && selectedMetricDetail?.selectedMetric?.name === 'Numbers' ? (
														<NumbersIcon />
													) : (
														getCurrencyIcon(
															selectedMetricDetail?.selectedCurrencyDetail?.name
																? selectedMetricDetail?.selectedCurrencyDetail.name
																: 'Dollar'
														)
													)}
												</InputAdornment>
											),
										}}
									/>
									<Box className='matrics-field-seprator' component='span'>
										{'/'}
									</Box>
									<TextField
										value={keyData?.targetValue || ''}
										disabled={keyData.isEditable === false}
										className='target-value helperText-bottom'
										id={'kr-target-date'}
										label={t('target')}
										placeholder={selectedCurrency ? '0' : '0'}
										fullWidth
										error={keyData?.isTargetValueError || ''}
										helperText={
											(keyData?.isTargetValueError && keyData?.krTargetValueErrorMsg && (
												<>
													<ErrorIcon />
													{keyData?.krTargetValueErrorMsg}
												</>
											)) ||
											''
										}
										// onChange={handelTargetValueChange}
										onChange={(event: any) => {
											setKeyData({
												...keyData,
												targetValue: event.target.value,
												isExpand: true,
												isTargetValueError: false,
												krTargetValueErrorMsg: '',
											});
										}}
										InputLabelProps={{
											shrink: true,
										}}
										inputProps={{ maxLength: Enums.MAX_LENGTH_CURRENT_TARGET }}
										name={selectedMetricDetail?.selectedMetric?.name !== 'Percentage' ? 'currency' : ''}
										InputProps={{
											...(selectedMetricDetail &&
												selectedMetricDetail?.selectedMetric?.name !== 'Percentage' && {
													inputComponent: NumberFormatComponent,
												}),
											startAdornment: (
												<InputAdornment position='start'>
													{selectedMetricDetail && selectedMetricDetail?.selectedMetric?.name === 'Percentage' ? (
														<PercentageIcon />
													) : selectedMetricDetail && selectedMetricDetail?.selectedMetric?.name === 'Numbers' ? (
														<NumbersIcon />
													) : (
														getCurrencyIcon(
															selectedMetricDetail?.selectedCurrencyDetail?.name
																? selectedMetricDetail?.selectedCurrencyDetail.name
																: 'Dollar'
														)
													)}
												</InputAdornment>
											),
										}}
									/>
								</Box>
							</Box>
						</Box>
					) : (
						<></>
					)}
					{currentUser && loggedInUserDetail.employeeId != currentUser?.employeeId && (
						<Box className='drawer-input-field'>
							<Box className='kr-assign-contributor'>
								<Box className='assign-contributor-label'>
									<FormLabel component='legend'>{t('ownerLabel')}</FormLabel>
								</Box>
							</Box>
							<Box className='add-more-contri'>
								<Box className='kr-attribute-avatar-list'>
									{currentUser && currentUser?.employeeId ? (
										currentUser && currentUser.imagePath ? (
											<Avatar
												className='avatar-default'
												alt={`${currentUser?.firstName} ${currentUser?.lastName}`}
												src={currentUser?.imagePath}
											/>
										) : (
											<Avatar className='avatar-default'>
												{getUserName({
													firstName: currentUser?.firstName,
													lastName: currentUser?.lastName,
													fullName: '',
												})}
											</Avatar>
										)
									) : loggedInUserDetail && loggedInUserDetail.imagePath ? (
										<Avatar
											className='avatar-default'
											alt={`${loggedInUserDetail?.firstName} ${loggedInUserDetail?.lastName}`}
											src={loggedInUserDetail?.imagePath}
										/>
									) : (
										<Avatar className='avatar-default'>
											{getUserName({
												firstName: loggedInUserDetail?.firstName,
												lastName: loggedInUserDetail?.lastName,
												fullName: '',
											})}
										</Avatar>
									)}
								</Box>
							</Box>
						</Box>
					)}
				</form>
			</Box>

			{modalProps && modalProps.open && (
				<DialogComponent
					module={modalProps.module || 'defaultKR'}
					modalOpen={modalProps.open}
					handleCloseModal={(e: any) => handleConfirmationCloseModal(e, 2)}
					matchString={modalProps?.details?.matchString || Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleConfirmationCloseModal(e, 1)}
					confirmMsg={modalProps?.details?.confirmMsg || ''}
					headingText={modalProps?.details?.headingText || t('deletePerformanceCycle')}
					subHeading={modalProps?.details?.subHeading || t('deletePerformanceCycleSubHead')}
				/>
			)}
		</>
	);
};
